<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Richiesta in corso, attendere...">
      <!-- CARD PRICIPALE DI CONTENIMENTO DI TUTTO IL FORM -->
      <b-card title="Scegli il tuo buono Welfare di Marca" class="mr-1 ml-1">

        <!-- PARTE DI TESTO PROMOZIONALE -->
        <h5 class='text-center mt-4'>Acquista il tuo <b>Buono Welfare di Marca</b> e spendilo con l'app <b>Ollipay</b> negli esercizi convenzionati del tuo territorio.</h5>

        <b-row class="mt-4" align-h="center">
          <b-col cols="12" class='text-center'>
            <b-link href="https://ollipay.it/" target="blank"><b-img width="500px" :src="ollipay_logo" fluid alt="ollipay icon"></b-img></b-link>
          </b-col>
        </b-row>

        <h5 class='text-center mt-4'>Scarica subito l'app e utilizza il tuo credito welfare per gli acquisti di tutti i giorni!</h5>

        <b-row class="mt-3" align-h="center">
          <b-col cols="12" md="2" class='text-center'>
            <b-link href="https://play.google.com/store/apps/details?id=wwpay.wellwork.it&hl=it&gl=US" target="blank"><b-img width="250px" :src="google_play_icon" fluid alt="google play icon"></b-img></b-link>
          </b-col>
          <b-col cols="12" md="2" class='text-center'>
            <b-link href="https://apps.apple.com/it/app/ollipay/id1601203063" target="blank"><b-img width="250px" :src="app_store_icon" fluid alt="app store icon"></b-img></b-link>
          </b-col>
        </b-row>

        <p class="mt-5">
          <b>ATTENZIONE:</b> <u>accertati di aver ricevuto le credenziali di accesso</u> all'app prima di scaricarla e procedere all'acquisto, se non hai ancora ricevuto i tuoi dati di accesso
          apri un ticket nella nostra <b-link :to="{ 'name' : 'site-assistenza'}" >area assistenza</b-link>.
        </p>

        <!-- FORM DI ACQUISTO DEL BUONO -->
        <!-- UTENTE HA SUFFICIENTE CREDITO -->
        <!-- Scelta del taglio in denaro del buono se si ha sufficiente credito -->
        <b-form v-if="can_buy" @submit.prevent="onSubmit">
          <!-- Oggetto del rimborso spese ( id categoria )-->
          <b-form-group id="group-buono-wfm"
            label="Scegli l'importo del buono:"
            label-for="buono-wfm"
          >
            <b-form-select id="buono-wfm"
              v-model="voucher_amount"
              :options="tagli_buoni"
              required></b-form-select>
          </b-form-group>
          <!-- Pulsante di invio -->
          <b-button :disabled="send_button_disabled" type="submit" variant="primary" class="mr-1">Invia richiesta</b-button>
        </b-form>

        <!-- UTENTE NON HA SUFFICIENTE CREDITO PER I TAGLI BUONI A DISPOSIZIONE -->
        <!-- Messaggio che informa l'utente che non può comperare buoni non avendo credito a sufficienza -->
        <h5 class='text-danger' v-else>Non si dispone di sufficiente credito per l'acquisto</h5>

      </b-card>
    </CustomOverlay>
  </div>
</template>

<script>

import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'OlliPayWfm',
  data () {
    return {
      // La tagline superiore.
      tagline_elem : [ { text : "Welfare Di Marca", link : 'conv-ollipay' } ],

      // Icone per lo scaricamento della App e logo Ollipay.
      app_store_icon   : require('@/assets/ollipay/App_Store_Badge_IT.jpg'),
      google_play_icon : require('@/assets/ollipay/Google_Play_Store_badge_IT.jpg'),
      ollipay_logo : require('@/assets/ollipay/ollipay_logo.jpg'),

      // Overlay di attesa
      overlay_show: false,

      // Tagli dei buoni, viene popolata in fase di creazione della
      // pagina con i tagli disponibili che sono caricati ad avvio
      // interfaccia tra i dati riguardanti Ollipay.
      // Per ora la inizializziamo con l'opzione di invito a scegliere
      tagli_buoni : [ { value: null, text: "Seleziona un'opzione", disabled: true } ],

      // Valore del buono scelto
      voucher_amount: null

    }
  },
  computed : {
    /**
     * Una piccola computed che ci serve per capire
     * se vi sono tagli che l'utente può comperare
     * tra quelli disponibili.
     * Altrimenti il form di acquisto non viene visualizzato.
     */
    can_buy : function () {
      // Facciamo sempre maggiore di 1 perchè i tagli sono inizializzati
      // con l'opzione non selezionabile: "Selezione un'opzione"
      return this.tagli_buoni.length > 1 ? true : false;
    },
    /**
     * Computed che rende attivo il pulsante di invio richiesta solo
     * dopo che è stato selezionato un buono
     */
    send_button_disabled : function () {
      return this.voucher_amount === null ? true : false;
    }
  },
  methods : {
    /**
     * Esecuzione dell'acquisto
     */
    onSubmit : function () {

      if ( this.voucher_amount === null ) {
        generalLib.backend_error_message_box( this, "Nessun buono selezionato, scegliere l'importo desiderato per proseguire." );
        return;
      }

      // Chiediamo conferma dell'acquisto ed eventualmente procediamo.
      generalLib.acquisto_confirm_message_box (  this, this.voucher_amount, 'art51c3' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla.
        if ( !value ) return;

        // Se invece l'utente decide di proseguire attivo
        // l'overlay e poi eseguo il post delle info.
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_ollipay_wfm_voucher , { importo : this.voucher_amount }  )
        .then( (response) => {

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home. Non possiamo usare quella della general lib perchè dobbiamo personalizzare
          // il messaggio.
          // TODO: rivedere il messaggio per personalizzarlo a dovere dopo aver accertato chi
          // deve inviare la comunicazione.
          let mess = "La richiesta è stata inviata con successo con l'id " + response.data.id_acquisto +
                     ". Riceverai a breve un messaggio di conferma nella tua casella di posta. " +
                     "Il voucher appena acquistato sarà spendibile accedendo all'app OlliPay."
          this.$bvModal.msgBoxOk( mess , {
            title: 'Richiesta inviata',
            buttonSize: 'sm',
            okVariant: 'success',
            centered: true
          })
          .then( ( value ) => {
            this.$router.push( { name : 'menu'} );
          })

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });
    }
  },
  created : function () {
    // Popoliamo l'array dei buoni a disposizione, inseriamo solo
    // i tagli acquistabili con il credito a disposizione.
    for( let val of this.$store.state.user.ollipay_status.vouchers ){
      if ( val <= this.$store.state.user.user_credito.art51c3 ) {
        this.tagli_buoni.push( { value: val, text: val + " €" } );
      }
    }
  },
  components: {
    PageTagline,
    CustomOverlay
  }
}
</script>

<style scoped></style>